import { inject as s, computed as o, withDirectives as b, openBlock as d, createElementBlock as m, unref as i, renderSlot as u, vShow as p } from "vue";
import { kebabCase as _ } from "lodash-es";
const v = ["id", "aria-labelledby", "area-selected"], f = /* @__PURE__ */ Object.assign({
  name: "DsTabItem"
}, {
  __name: "tab-item",
  props: {
    title: { type: String, required: !0 }
  },
  setup(r) {
    const e = r, c = s("registerTab", () => {
    }), l = s("activeTab", {}), t = _(e.title), a = o(() => l.value === e.title);
    return c({ title: e.title, slug: t }), (n, g) => b((d(), m("div", {
      id: `tab-content-${i(t)}`,
      role: "tabpanel",
      "aria-labelledby": `tab-${i(t)}`,
      "area-selected": a.value,
      class: "ds-tabs__content",
      "data-j-tab-item": ""
    }, [
      u(n.$slots, "default")
    ], 8, v)), [
      [p, a.value]
    ]);
  }
}), $ = f;
export {
  $ as default
};
